/**
 * Domain & Subdomain Helper Utility
 * Handles routing and URL resolution for the 27 Nakshatra Homam Subdomain
 * Subdomain: 27nakshatrahomam.srignanasaibabamandir.com
 */

export const MAIN_SITE_URL = process.env.REACT_APP_MAIN_URL || "https://srignanasaibabamandir.com";
export const HOMAM_SUBDOMAIN_URL = process.env.REACT_APP_HOMAM_URL || "https://27nakshatrahomam.srignanasaibabamandir.com";

/**
 * Checks if the current window location is on the 27 Nakshatra Homam subdomain
 * Works for production, custom subdomain names, and local testing
 */
export const isHomamSubdomain = () => {
  if (typeof window === "undefined") return false;
  const hostname = window.location.hostname.toLowerCase();

  // Match production / staging subdomains
  if (
    hostname.includes("27nakshathra") ||
    hostname.includes("27nakshatra") ||
    hostname.startsWith("homam.") ||
    hostname.startsWith("nakshatra.") ||
    hostname.startsWith("yagna.")
  ) {
    return true;
  }

  // Support local development testing with query param or port (?portal=homam or ?subdomain=homam)
  const params = new URLSearchParams(window.location.search);
  if (params.get("subdomain") === "homam" || params.get("portal") === "homam") {
    return true;
  }

  return false;
};

/**
 * Returns the appropriate relative path for Nakshatra Homam pages
 * If on subdomain: returns '/today', '/booking', '/gallery', etc.
 * If on main domain: returns '/nakshatra-homam/today', '/nakshatra-homam/booking', etc.
 */
export const getHomamPath = (path = "") => {
  const isSub = isHomamSubdomain();
  const cleanPath = path.startsWith("/") ? path : `/${path}`;

  if (isSub) {
    if (cleanPath === "/" || cleanPath === "/nakshatra-homam" || cleanPath === "/nakshatra-homam/") {
      return "/";
    }
    if (cleanPath === "/registration" || cleanPath === "/homam-registration") {
      return "/homam-registration";
    }
    if (cleanPath === "/booking" || cleanPath === "/homam-booking") {
      return "/booking";
    }
    if (cleanPath.startsWith("/nakshatra-homam/")) {
      return cleanPath.replace("/nakshatra-homam", "");
    }
    return cleanPath;
  }

  // On main site
  if (cleanPath === "/" || cleanPath === "" || cleanPath === "/nakshatra-homam") {
    return "/nakshatra-homam";
  }
  if (cleanPath === "/registration" || cleanPath === "/homam-registration") {
    return "/homam-registration";
  }
  if (cleanPath === "/booking" || cleanPath === "/homam-booking") {
    return "/nakshatra-homam/booking";
  }
  if (!cleanPath.startsWith("/nakshatra-homam")) {
    return `/nakshatra-homam${cleanPath}`;
  }
  return cleanPath;
};

/**
 * Returns external URL to Main Temple Website
 */
export const getMainSiteExternalUrl = (subpath = "/") => {
  const cleanSubpath = subpath.startsWith("/") ? subpath : `/${subpath}`;
  if (typeof window !== "undefined") {
    const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    if (isLocal && !window.location.search.includes("subdomain=homam")) {
      return cleanSubpath;
    }
  }
  return `${MAIN_SITE_URL}${cleanSubpath}`;
};

/**
 * Returns external URL to 27 Nakshatra Homam Subdomain / Portal
 */
export const getHomamExternalUrl = (subpath = "/") => {
  const cleanSubpath = subpath.startsWith("/") ? subpath : `/${subpath}`;
  if (typeof window !== "undefined") {
    const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    if (isLocal) {
      return `/nakshatra-homam${cleanSubpath === "/" ? "" : cleanSubpath}`;
    }
  }
  return `${HOMAM_SUBDOMAIN_URL}${cleanSubpath === "/" ? "" : cleanSubpath}`;
};
